import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'
import { history } from 'src/core/router'
import { transformTime, transformTimeDate } from 'src/helper/tool'
import {
  message
} from 'antd'
import moment from 'moment'

export default class {
  // 翻页数据
  @observable listData = {
    loading: false,
    count: 0,
    list: [],
    pageSize: 0,
    page: 0
  }

  @observable data = {
  }

  @action resetData() {
    this.data = {
      deliveryTimeTs: 0,
      targetPlatform: 3,
      language: ['en', 'ar', 'tr', 'zh'],
      ltype: 0,
      msgltype: 0,
    }
  }

  @action setTargetPlatform(d) {
    this.data.targetPlatform = d
  }

  @action setDeliveryTimeTs(d) {
    this.data.deliveryTimeTs = d
  }

  @action setLanguage(d) {
    this.data.language = d
  }

  @action setLtype(d) {
    this.data.ltype = d
  }

  @action setMsgltype(d) {
    this.data.msgltype = d
  }

  // 默认表单
  @observable form = { method: '', data: {}, modal: false, modal2: false, submit: false }

  // 选择的行数
  @observable selectRow = []

  // 默认搜索条件
  @observable searchMap = {
    pageSize: 50,
    page: 1
  }

  // 设置搜索条件
  @action searchSet(map = {}, rewrite = false) {
    let params = {}
    for (let k in map) {
      if (map[k] || map[k] === 0) {
        params[k] = map[k]
      }
    }

    params.pageSize = params.pageSize || this.searchMap.pageSize
    params.page = params.page || this.searchMap.page
    // 重写search map条件
    if (rewrite) {
      params.pageSize = this.searchMap.pageSize
      params.page = this.searchMap.page
      this.searchMap = params
    } else {
      this.searchMap = Object.assign(toJS(this.searchMap), params)
    }
    return toJS(this.searchMap)
  }

  @action setForm(o = {}) {
    this.form = Object.assign(this.form, o || {})
  }

  @action openModalForm(o = {}) {
    this.resetData()
    this.form.data = {}
    this.form.name = '创建'
    this.form.modal = true
  }

  @action openModalFormEdit(o = {}, name) {
    this.resetData()
    o.dateTime = o.deliveryTimeTs > 0 ? moment(o.deliveryTimeTs * 1000).format('YYYY-MM-DD HH:mm:ss') : ""
    if (o.pushTaskPushContentMap) {
      if (o.pushTaskPushContentMap.ar) {
        o.pushtitleAr = o.pushTaskPushContentMap.ar.title
        o.pushdescriptionAr = o.pushTaskPushContentMap.ar.description
      }
      if (o.pushTaskPushContentMap.tr) {
        o.pushtitleTr = o.pushTaskPushContentMap.tr.title
        o.pushdescriptionTr = o.pushTaskPushContentMap.tr.description
      }
      if (o.pushTaskPushContentMap.en) {
        o.pushtitleEn = o.pushTaskPushContentMap.en.title
        o.pushdescriptionEn = o.pushTaskPushContentMap.en.description
      }
      if (o.pushTaskPushContentMap.zh) {
        o.pushtitleZh = o.pushTaskPushContentMap.zh.title
        o.pushdescriptionZh = o.pushTaskPushContentMap.zh.description
      }
    }
    if (o.pushTaskMsgContentMap) {
      if (o.pushTaskMsgContentMap.ar) {
        o.msgtitleAr = o.pushTaskMsgContentMap.ar.title
        o.msgdescriptionAr = o.pushTaskMsgContentMap.ar.description
        o.msgcoverUrlAr = o.pushTaskMsgContentMap.ar.coverUrl
      }
      if (o.pushTaskMsgContentMap.tr) {
        o.msgtitleTr = o.pushTaskMsgContentMap.tr.title
        o.msgdescriptionTr = o.pushTaskMsgContentMap.tr.description
        o.msgcoverUrlTr = o.pushTaskMsgContentMap.tr.coverUrl
      }
      if (o.pushTaskMsgContentMap.en) {
        o.msgtitleEn = o.pushTaskMsgContentMap.en.title
        o.msgdescriptionEn = o.pushTaskMsgContentMap.en.description
        o.msgcoverUrlEn = o.pushTaskMsgContentMap.en.coverUrl
      }
      if (o.pushTaskMsgContentMap.zh) {
        o.msgtitleZh = o.pushTaskMsgContentMap.zh.title
        o.msgdescriptionZh = o.pushTaskMsgContentMap.zh.description
        o.msgcoverUrlZh = o.pushTaskMsgContentMap.zh.coverUrl
      }
    }
    if (o.pushJumpUrl && o.pushJumpUrl != '') {
      if (o.pushJumpUrl.indexOf('http') > -1) {
        o.url = o.pushJumpUrl
        o.ltype = 3
      }
      if (o.pushJumpUrl.indexOf('vochat://room/join?gid=') > -1) {
        o.dgid = parseInt(o.pushJumpUrl.replace('vochat://room/join?gid=', ''))
        o.ltype = 1
      }
      if (o.pushJumpUrl.indexOf('vochat://wallet/recharge?index=0') > -1) {
        o.ltype = 4
      }
      if (o.pushJumpUrl.indexOf('vochat://wallet/recharge?index=1') > -1) {
        o.ltype = 5
      }
    } else {
      o.ltype = -1
    }
    if (o.msgJumpUrl && o.msgJumpUrl != '') {
      if (o.msgJumpUrl.indexOf('http') > -1) {
        o.msgurl = o.msgJumpUrl
        o.msgltype = 3
      }
      if (o.msgJumpUrl.indexOf('vochat://room/join?gid=') > -1) {
        o.msgdgid = parseInt(o.msgJumpUrl.replace('vochat://room/join?gid=', ''))
        o.msgltype = 1
      }
      if (o.msgJumpUrl.indexOf('vochat://wallet/recharge?index=0') > -1) {
        o.msgltype = 4
      }
      if (o.msgJumpUrl.indexOf('vochat://wallet/recharge?index=1') > -1) {
        o.msgltype = 5
      }
    } else {
      o.msgltype = -1
    }

    //更新状态
    if (o.uids && o.uids != "") {
      this.data.targetPlatform = 0
    }

    if (o.deliveryTimeTs != undefined && o.deliveryTimeTs > 0) {
      this.data.deliveryTimeTs = 1
    }

    if (o.language && o.language != "") {
      this.data.language = o.language.split(',')
    }

    if (o.ltype != undefined && o.ltype != 0) {
      this.setLtype(o.ltype)
    }

    if (o.msgltype != undefined && o.msgltype != 0) {
      this.setMsgltype(o.msgltype)
    }

    this.tmpForm = o
    this.form.data = {}
    this.form.name = name || '编辑'
    this.form.data = o
    if (name == '审核') {
      this.form.modal2 = true
    } else {
      this.form.modal = true
    }
  }

  //////////////////下面本页面业务////////////////////////

  // 发起搜索
  @action async get(map = {}) {
    console.log('搜索条件', map)
    console.log('目前表单', this.form)
    this.selectRow = []
    this.listData.loading = true
    let d = await http.post(`/api/pushtask/list`, map)
    this.listData.loading = false
    if (d.code == 999) {
      localstorage.remove('userToken')
      history.push('/oauth/login/index')
    }
    if (d.code == 0 && d.res) {
      for (let index = 0; index < d.res.length; index++) {
        d.res[index].diyid = index + 1
      }
      this.listData.count = d.count
      this.listData.list = d.res
      this.listData.pageSize = map.pageSize || this.searchMap.pageSize
      this.listData.page = map.page || 1
    } else {
      this.listData.count = 0
      this.listData.list = []
      this.listData.pageSize = this.searchMap.pageSize
      this.listData.page = 1
    }
    console.log("搜索结果", d)
  }

  @observable pushStatus = [
    { value: -2, name: '已删除' },
    { value: -1, name: '拒绝' },
    { value: 1, name: '未提交审核' },
    { value: 2, name: '审核中' },
    { value: 3, name: '审核通过' },
    { value: 4, name: '发布完成' }
  ]

  @observable pushStatus3 = [
    { value: 0, name: '所有' },
    { value: -3, name: '发送失败' },
    { value: -2, name: '已删除' },
    { value: -1, name: '拒绝' },
    { value: 1, name: '未提交审核' },
    { value: 2, name: '审核中' },
    { value: 3, name: '审核通过' },
    { value: 4, name: '发布完成' }
  ]

  @observable pushStatus2 = [
    { value: -1, name: '拒绝' },
    { value: 3, name: '审核通过' }
  ]

  @observable pushTaskType = [
    { value: 1, name: '推送' },
    { value: 2, name: '消息' },
    { value: 3, name: '消息+推送' }
  ]

  @observable deliveryTimeTs = [
    { value: 0, name: '立即发送' },
    { value: 1, name: '定时发送' }
  ]

  @observable msgStyle = [
    { value: 1, name: '公告' },
    { value: 2, name: '系统消息' }
  ]

  @observable ltypeListN2 = [
    { value: -1, name: '返回app' },
    { value: 1, name: '打开房间' },
    { value: 3, name: '打开H5链接' },
    { value: 4, name: '打开充值页' },
    { value: 5, name: '打开钱包钻石' }
  ]

  @observable ltypeListN3 = [
    { value: -1, name: '无跳转' },
    { value: 1, name: '打开房间' },
    { value: 3, name: '打开H5链接' },
    { value: 4, name: '打开充值页' },
    { value: 5, name: '打开钱包钻石' }
  ]

  @observable langList2 = [
    { value: 'en', label: '英语' },
    { value: 'ar', label: '阿拉伯语' },
    { value: 'tr', label: '土耳其' },
    { value: 'zh', label: '中文' },
  ]

  @observable osType2 = [
    { value: 0, name: '指定用户' },
    { value: 1, name: 'ios' },
    { value: 2, name: '安卓' },
    { value: 3, name: '全部' }
  ]

  @observable tmpForm = {}
}



// WEBPACK FOOTER //
// ./store/push.js